<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      Master
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/donationtypes">
        Jenis Bantuan
      </Link>
      <span class="text-black-400 font-medium"> / </span>
      {{ form.name }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input
            v-model="form.name"
            :error="form.errors.name"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Name" />
          <textarea-input
            v-model="form.description"
            :error="form.errors.description"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Description" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button
            v-if="!donationType.deleted_at"
            class="text-red-600 hover:underline"
            tabindex="-1"
            type="button"
            @click="destroy">
            Delete Jenis Bantuan
          </button>
          <loading-button
            :loading="form.processing"
            class="btn-indigo ml-auto"
            type="submit">
            Update Jenis Bantuan
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'

export default {
    components: {
        Head,
        Link,
        LoadingButton,
        TextInput,
        TextareaInput,
    },
    layout: Layout,
    props: {
        donationType: Object,
    },
    remember: 'form',
    data () {
        return {
            form: this.$inertia.form({
                name: this.donationType.name,
                description: this.donationType.description,
            }),
        }
    },
    methods: {
        update () {
            this.form.put(`/donationtypes/${this.donationType.id}`)
        },
        destroy () {
            if (confirm('Are you sure you want to delete this Donation Type?')) {
                this.$inertia.delete(`/donationtypes/${this.donationType.id}`)
            }
        },
        restore () {
            if (confirm('Are you sure you want to restore this Donation Type?')) {
                this.$inertia.put(`/donationtypes/${this.donationType.id}/restore`)
            }
        },
    },
}
</script>
